import React, { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    ModalHeader,
} from "../Styles/InputStyles";
import { MdClose } from "react-icons/md";
import tw from "tailwind-styled-components";
import * as Yup from "yup";

const locationSchema = Yup.object().shape({
    locationName: Yup.string()
        .matches(/^[A-Za-z0-9\s.,'-]+$/, "Only letters, numbers, spaces and basic punctuation are allowed")
        .min(4, "Location name must be at least 4 characters long")
        .max(100, "Location name must not exceed 100 characters")
        .required("Location name is required"),
});

const AddLocation = ({ addLocationMutate, addLocationLoading, handleClose }) => {
    const [height, setHeight] = useState(window.innerHeight);

    const initialValues = {
        locationName: "",
        description: "",
    }

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleSubmit = (values) => {
        addLocationMutate({
            name: values.locationName,
            description: values.description,
        });
    };

    return (
        <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">Add Location</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>
            <div className="px-6 h-full flex flex-col justify-between">
                <Formik
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    validationSchema={locationSchema}
                >
                    {({ errors, touched }) => (
                        <Form>
                            <ScrollableContent className="max-h-[calc(100dvh-140px)]">
                                <Wrapper>
                                    <InputGroup>
                                        <Label htmlFor="locationName">Location Name *</Label>
                                        <FieldWrappers>
                                            <Field
                                                type="text"
                                                name="locationName"
                                                id="locationName"
                                                autoComplete="off"
                                                placeholder="Enter location name"
                                                className="w-full"
                                            />
                                        </FieldWrappers>
                                        {errors.locationName && touched.locationName && (
                                            <ErrorMessage>{errors.locationName}</ErrorMessage>
                                        )}
                                    </InputGroup>
                                    <InputGroup>
                                        <Label htmlFor="description">Describe the Location</Label>
                                        <FieldWrapper>
                                            <Field
                                                as={Textarea}
                                                id="description"
                                                name="description"
                                                rows={4}
                                                maxLength={500}
                                                placeholder="Write your description here..."
                                            />
                                        </FieldWrapper>
                                    </InputGroup>
                                </Wrapper>
                            </ScrollableContent>
                            <ActionSection>
                                <SideCancelBtn type="button" onClick={handleClose}>
                                    Cancel
                                </SideCancelBtn>
                                <SubmitBtn type="submit" disabled={addLocationLoading}>
                                    {addLocationLoading ? "Processing..." : "Submit"}
                                </SubmitBtn>
                            </ActionSection>
                        </Form>
                    )}
                </Formik>
            </div>
        </Container>
    );
};

const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-[#0078BD] py-4 px-4`;
const ErrorMessage = tw.div`text-red-500 text-xs mt-1`;
const Textarea = tw.textarea`min-h-30 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600  focus:border-sky-600 focus:outline-none duration-200 w-full h-30 resize-y  break-words overflow-hidden`;
const FieldWrapper = tw.div`w-full`;
export default AddLocation;